import types from './types';

const toggleDataPrivacy = () => ({
    type: types.SET_DATA_PRIVACY,
    params: {}
});

export default {
    toggleDataPrivacy
};
